const ticker = [
  { num: "128", label: "今日炸点", unit: "条" },
  { num: "862", label: "全网围观话题", unit: "万" },
  { num: "7", label: "常设栏目", unit: "个" },
  { num: "15", label: "每小时热度刷新", unit: "次" },
];

const chips = [
  { text: "综艺名场面", icon: "ri-tv-2-line" },
  { text: "热门剧集", icon: "ri-film-line" },
  { text: "红毯高光", icon: "ri-star-smile-line" },
  { text: "打工人热梗", icon: "ri-bubble-chart-line" },
  { text: "夜经济", icon: "ri-earth-line" },
  { text: "新机发布", icon: "ri-rocket-line" },
];

export default function Hero() {
  return (
    <section id="home" className="relative overflow-hidden bg-background-50">
      <div
        className="pointer-events-none absolute -right-40 -top-40 h-[480px] w-[480px] rounded-full opacity-60"
        style={{
          background:
            "radial-gradient(circle at center, rgba(232,84,47,0.14), rgba(237,155,13,0.06) 55%, transparent 72%)",
        }}
      ></div>
      <div
        className="pointer-events-none absolute -left-32 bottom-0 h-[420px] w-[420px] rounded-full opacity-50"
        style={{
          background:
            "radial-gradient(circle at center, rgba(237,155,13,0.12), transparent 70%)",
        }}
      ></div>

      <div className="relative mx-auto grid max-w-7xl items-center gap-8 px-4 pb-14 pt-28 md:px-6 md:pb-20 md:pt-36 lg:grid-cols-[1.05fr_0.95fr] lg:gap-12">
        <div className="text-center lg:text-left">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-semibold text-primary-700">
            <i className="ri-fire-fill text-sm" aria-hidden="true"></i>
            每日全网热门爆点 · 实时更新
          </span>

          <h1 className="mt-6 text-3xl font-black leading-tight tracking-tight text-foreground-950 sm:text-4xl lg:text-[2.9rem]">
            今天，全网都在
            <span className="relative mx-1 inline-block text-primary-500">
              围观
              <svg
                className="absolute -bottom-1 left-0 h-2 w-full"
                viewBox="0 0 100 8"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <path d="M1 6C20 2 40 6 60 4 78 2.5 92 4.5 99 3" stroke="#ED9B0D" strokeWidth="3" fill="none" strokeLinecap="round" />
              </svg>
            </span>
            什么瓜？
          </h1>

          <p className="mx-auto mt-6 max-w-xl text-base leading-relaxed text-foreground-700 lg:mx-0">
            吃瓜爆网把今日炸点、爆点事件与全网围观话题一网打尽。娱乐、影视、综艺、
            热梗、社会议题滚动推送，直击最热瓜田现场，让你不错过任何一场"全网都在聊"。
          </p>

          <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row sm:justify-center lg:justify-start">
            <a
              href="#today"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
            >
              <i className="ri-flashlight-fill text-base" aria-hidden="true"></i>看今日炸点
            </a>
            <a
              href="#ranking"
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-3 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 sm:w-auto"
            >
              围观实时榜单
              <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
            </a>
          </div>

          <div className="mt-10 grid grid-cols-4 gap-2 border-t border-background-200 pt-6 sm:gap-3">
            {ticker.map((t) => (
              <div key={t.label} className="text-center lg:text-left">
                <p className="text-xl font-black text-primary-600 sm:text-2xl">
                  {t.num}
                  <span className="ml-0.5 text-xs font-bold text-foreground-500">{t.unit}</span>
                </p>
                <p className="mt-0.5 text-[11px] font-medium text-foreground-600 sm:text-xs">{t.label}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="overflow-hidden rounded-2xl border border-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=stylized%20editorial%20illustration%20in%20warm%20coral%20red%20amber%20and%20cream%20palette%20with%20soft%20geometric%20shapes%2C%20giant%20watermelon%20melon%20being%20watched%20by%20a%20crowd%20of%20curious%20silhouettes%20holding%20phones%2C%20floating%20chat%20bubbles%20and%20fire%20sparks%20and%20news%20tags%20rising%20around%2C%20energetic%20trending%20news%20theme%2C%20clean%20minimal%20vector%20art%2C%20cohesive%20warm%20tone%2C%20no%20text&width=900&height=1100&seq=hero-visual-x1&orientation=portrait"
              alt="吃瓜爆网追热点围观场景主视觉插画"
              className="h-[380px] w-full object-cover sm:h-[460px] lg:h-[520px]"
            />
          </div>
          <span className="absolute -left-3 top-6 rounded-full bg-accent-500 px-3 py-1.5 text-xs font-bold text-background-50 shadow-[0_6px_18px_rgba(237,155,13,0.35)] lg:-left-6">
            今日炸点 · 热播中
          </span>
          <span className="absolute -right-2 bottom-8 flex items-center gap-1.5 rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs font-semibold text-foreground-800 lg:-right-4">
            <i className="ri-eye-line text-primary-500" aria-hidden="true"></i>
            862 万人正在围观
          </span>
        </div>
      </div>

      <div className="relative mx-auto -mt-2 max-w-7xl px-4 pb-10 md:px-6">
        <div className="flex flex-wrap items-center justify-center gap-2 lg:justify-start">
          {chips.map((c) => (
            <span
              key={c.text}
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100 px-3 py-1.5 text-xs font-medium text-foreground-700 ring-1 ring-background-200"
            >
              <i className={`${c.icon} text-primary-500`} aria-hidden="true"></i>
              {c.text}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}